export default {
    title: 'External evaluation (link)',
    tooltip: 'Invite people to the trend evaluation via a link. The people do not need access to the Trendmanager. The voting takes place completely anonymously. No conclusions are possible as to which participants have started the evaluation completely, incompletely or not at all.',

    enabled: {
        true: 'Evaluation active',
        false: 'Evaluation inactive',
        tooltip: {
            globallyDisabled: 'The evaluations have been disabled at the level of the trend radar or panel',
            toggle: {
                true: 'Disable external evaluation (link) in this panel',
                false: 'Enable external evaluation (link) in this panel'
            }
        }
    },

    download: {
        label: 'Download evaluation data',
        tooltip: 'Download evaluation data (CSV)'
    },

    delete: {
        label: 'Remove participations',
        tooltip: {
            ok: 'Remove participations',
            alreadyEmpty: 'There are no participations of an external evaluation (link) in this panel'
        }
    },

    remove: {
        title: 'Remove all participations',
        notice: 'Attention: This step can not be undone.',
        content: 'Should all participations be removed from the trend evaluation in this panel?',
        confirm: 'Yes, remove now!'
    },

    tab: {
        overview: 'Overview',
        feedback: 'Feedback',
        intro: 'Welcome text',
        logo: 'Logo'
    }
}
